
import "video.js/dist/video-js.css";
import { defineComponent } from "vue";
import "@/assets/styles/custom.css";
import LoadingSpinner from "@/components/loading_state/LoadingSpinner.vue";
import ConfirmationModalV2 from "@/components/modals/ConfirmationModal.vue";
import AuthMixins from "@/mixins/AuthMixins";
import logger from "@/services/logger";

export default defineComponent({
  name: "App",
  components: { ConfirmationModalV2, LoadingSpinner },
  data() {
    return {
      authResolved: false as boolean,
    };
  },
  mixins: [AuthMixins],
  async mounted() {
    let session: unknown | undefined = undefined;
    try {
      session = await this.refreshSession();
    } catch (error) {
      logger.error("Unable to refresh session", error as Error);
    } finally {
      if (!session) {
        await this.$router.isReady();
        if (this.$route.meta.requireLogin) {
          this.saveReturnUrl();

          this.$router.replace("/log-in");
        }
      }
      setTimeout(() => {
        this.authResolved = true;
      }, 0);
    }
  },
});
